import { render, staticRenderFns } from "./ReportExamComponent.vue?vue&type=template&id=3bed6748&scoped=true&"
import script from "./ReportExamComponent.vue?vue&type=script&lang=js&"
export * from "./ReportExamComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReportExamComponent.vue?vue&type=style&index=0&id=3bed6748&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bed6748",
  null
  
)

export default component.exports